import React, { Component } from 'react';

import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {   addPreschool, getSchoolListDatas, getLocationList, emailExist_check, sclList,
  presclEdit, presclReject, commonAPI } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { MOBILE_REGEX, URL_REGEX } from '../../constant.js';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

const FacilitesArray = [{"id":1,"facility":"CCTV"},{"id":2,"facility":"AC Classes"},{"id":3,"facility":"Transportation"},{"id":4,"facility":"Food and Snacks"},{"id":5,"facility":"Outdoor Play area"},{"id":6,"facility":"NA"}];
const TimingsArray = [{"id":1,"timing":"01:00"},{"id":2,"timing":"01:30"},{"id":3,"timing":"02:00"},{"id":4,"timing":"02:30"},{"id":5,"timing":"03:00"},{"id":6,"timing":"03:30"},{"id":7,"timing":"04:00"},{"id":8,"timing":"04:30"},{"id":9,"timing":"05:00"},{"id":10,"timing":"05:30"},{"id":11,"timing":"06:00"},{"id":12,"timing":"06:30"},{"id":13,"timing":"07:00"},{"id":14,"timing":"07:30"},{"id":15,"timing":"08:00"},{"id":16,"timing":"08:30"},{"id":17,"timing":"09:00"},{"id":18,"timing":"09:30"},{"id":19,"timing":"10:00"},{"id":20,"timing":"10:30"},{"id":21,"timing":"11:00"},{"id":22,"timing":"11:30"},{"id":23,"timing":"12:00"},{"id":24,"timing":"12:30"},{"id":25,"timing":"NA"}];
const PaymentArray = [{"id":1,"payment_name":"Cash"},{"id":2,"payment_name":"Card"},{"id":3,"payment_name":"Cheque"},{"id":4,"payment_name":"Online Payments"},{"id":5,"payment_name":"NA"}];
const BoeArray = [{"id":1,"name":"Boarding"},{"id":2,"name":"Home Schools"},{"id":3,"name":"IB"},{"id":4,"name":"Public Schools"},{"id":5,"name":"IGCSE"},{"id":6,"name":"CBSE"},{"id":7,"name":"Special Needs"},{"id":8,"name":"NA"}];

class verticalPreSchoolEdit extends Component {

 constructor(props) {
    super(props);
    this.state = {
      errors: [],
      ownerName: '',
      pageid: '',
      isrefund: '',
      user_type: 0,
      registration_no: '',
      schoolName: '',
      email_id: '',
      phone_number: '',
      // landline_number: '',
      fax_number: '123',
      website: '',
      state: '',
      location: 'Bengaluru',
      pincode: '',
      country: '',
      address: '',
      about_school: '',
      google_location: '',
      schoolType: [],
      board_of_education: '',
      opening_timimg: '1',
      number_of_teachers: '',
      establishment_Year: '',
      avg_anual_fee: '',
      other_fee: '',
      addmission_fee: '',
      admission_link: '',
      processing_fee: '',
      required_document: [],
      admission_process: '',
      facilities: [],
      photos: '',
      images: '',
      facilitiesList: FacilitesArray,
      boeList: BoeArray,
      timingList: TimingsArray,
      mopList: PaymentArray,
      documnets_drop: [],
      categoryTypeList: [
        {
          "category_id": 16,
          "category_name": "Kindergarten",
          "is_parent": 0,
          "parent": "Pre-Schools"
        },
        {
          "category_id": 17,
          "category_name": "Montessori",
          "is_parent": 0,
          "parent": "Pre-Schools"
        },
        {
          "category_id": 18,
          "category_name": "Play Group",
          "is_parent": 0,
          "parent": "Pre-Schools"
        },
        {
          "category_id": 20,
          "category_name": "Special Needs",
          "is_parent": 0,
          "parent": "Pre-Schools"
        },
        {
          "category_id": 175,
          "category_name": "Day care or Creche",
          "is_parent": 0,
          "parent": "Pre-Schools"
        }
      ],
      getId: this.props.match.params.id ? this.props.match.params.id : '',
      latitude: '',
      longitude: '',
      other_rating: '',
      attachment_file: [],
      attachment_file_length: 0,
      attachment_fileName: [],
      from_time: '',
      from_time_cate: 'AM',
      to_time: '',
      to_time_cate: 'AM',
      delete_array: [],
      keywords: '',
      edit_image: '',
      tempBanner: '',
      location_list: [
        {
          "id": 1,
          "location": "Bengaluru",
          "latitude": "12.9716",
          "longitude": "77.5946",
          "status": 1,
          "sort_order": 1
        },
        {
          "id": 12,
          "location": "Chennai",
          "latitude": "13.0569",
          "longitude": "80.2425",
          "status": 1,
          "sort_order": 2
        },
        {
          "id": 11,
          "location": "Coimbatore",
          "latitude": "11.0168",
          "longitude": "76.9558",
          "status": 1,
          "sort_order": 3
        },
        {"id":27,"location":"Hosur","latitude":"12.7409","longitude":"77.8253","status":1,"sort_order":4},
        {
          "id": 2,
          "location": "Hyderabad",
          "latitude": "17.3850",
          "longitude": "78.4867",
          "status": 1,
          "sort_order": 4
        },
        {
          "id": 24,
          "location": "Madurai",
          "latitude": "9.9252",
          "longitude": "78.1198",
          "status": 1,
          "sort_order": 5
        },
        {
          "id": 13,
          "location": "Mumbai",
          "latitude": "19.0760",
          "longitude": "72.8777",
          "status": 1,
          "sort_order": 7
        },
        {
          "id": 15,
          "location": "Kolkata",
          "latitude": "22.5726",
          "longitude": "88.3639",
          "status": 1,
          "sort_order": 8
        },
        {
          "id": 16,
          "location": "New Delhi",
          "latitude": "28.6139",
          "longitude": "77.2090",
          "status": 1,
          "sort_order": 9
        },
        {
          "id": 17,
          "location": "Jaipur",
          "latitude": "26.9124",
          "longitude": "75.7873",
          "status": 1,
          "sort_order": 10
        },
        {
          "id": 18,
          "location": "Chandigarh",
          "latitude": "30.7333",
          "longitude": "76.7794",
          "status": 1,
          "sort_order": 11
        },
        {
          "id": 19,
          "location": "Pune",
          "latitude": "18.5204",
          "longitude": "73.8567",
          "status": 1,
          "sort_order": 12
        },
        {
          "id": 20,
          "location": "Kochi",
          "latitude": "9.9312",
          "longitude": "76.2673",
          "status": 1,
          "sort_order": 13
        },
        {
          "id": 21,
          "location": "Noida",
          "latitude": "28.5355",
          "longitude": "77.3910",
          "status": 1,
          "sort_order": 14
        },
        {
          "id": 22,
          "location": "Agra",
          "latitude": "27.1767",
          "longitude": "78.0081",
          "status": 1,
          "sort_order": 15
        },
        {
          "id": 23,
          "location": "Puducherry",
          "latitude": "11.9416",
          "longitude": "79.8083",
          "status": 1,
          "sort_order": 16
        },
        {
          "id": 25,
          "location": "Tiruchirappalli",
          "latitude": "10.7905",
          "longitude": "78.7047",
          "status": 1,
          "sort_order": 17
        }
        ,{"id":26,"location":"Indore","latitude":"22.719568","longitude":"75.857727","status":1,"sort_order":18}
      ],
      min_age: '',
      has_trial: 2,
      sclList: [],
      has_scl: 2,
      scl_link: 0,
      preview: false,
      edited_data: [],
      keywordsArr: [],
      edited: false
    };
    this.validator = new SimpleReactValidator({
      validators: {
        checkExist: {  // name the rule
          message: 'The :attribute field is required.',
          rule: (val, params, validator) => {
            if (val === '' && this.state.edit_image === '') {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        emailExist_check: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isEmailValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });

    // this.Cat_type();
  }
  componentDidMount() {

    this.getSclList(); 
    this.getKeywords();
    //this.gettiming(); 
    //this.getboe(); 
    this.getdocuments();
    //this.getfacilities();
    //this.getpayment_type(); 

    let user_data = localStorage.getItem("user_data");
    let auth_data = JSON.parse(user_data);
    this.setState({
      login_id: auth_data.login_id,
      role: auth_data.role,
    });
    if (this.state.getId) {
      this.getPreSchoolInfo();
    }

    //this.LocationDataList();
  }
  validateMail = (value, catgry, vendr_id, pageid) => {
    let name = 'email_id';
    let type_name = 'isEmailValid';
    let req = JSON.stringify({
      [name]: value,
      category: catgry,
      vendor_id: vendr_id,
      pageid: pageid
    });
    emailExist_check(req).then(res => {
      console.log('valuee', res);
      if (res.status === 1) {
        this.setState({
          [type_name]: false
        });
      } else {
        // return res.status;
        this.setState({
          [type_name]: true
        });
      }
    });
  }
  getKeywords = () => {
    commonAPI(JSON.stringify({ url: 'get_site_keywords', vertical:'preschool'  })).then((res) => {
      if (res.status === 1) {
        this.setState({
          keywordsArr: res.results
        })
      }
    })
  }
  async getPreSchoolInfo() {
    let response = await presclEdit(JSON.stringify({ id: this.state.getId }));
    console.log(response);
    if (response.status === 1) {
      const data = response.data, edited_data = response.original;
      this.setState({
        registration_no: data.registration_no,
        pageid: data.id,
        ownerName: data.owner_name,
        schoolName: data.organisation_name,
        sub_categories: data.sub_categories.split(','),
        email_id: data.email_id,
        phone_number: data.phone_number,
        fax_number: data.fax_number,
        state: data.state,
        website: data.website,
        location: data.location,
        address: data.address,
        country: data.country,
        pincode: data.pincode,
        about_school: data.about,
        google_location: data.google_location,
        number_of_teachers: data.number_of_teachers,
        board_of_education: data.edu_type,
        establishment_Year: data.est_year,
        facilities: data.amenities.split(','),
        avg_anual_fee: data.avg_fee,
        other_fee: data.other_fee,
        processing_fee: data.processing_fee,
        admission_process: (data.admission_process==='')?'NA':data.admission_process,
        addmission_fee: data.admit_fee,
        admission_link: data.admission_link,
        required_document: data.required_document.split(','),
        isrefund: data.is_refund,
        attachment_file: data.photo_arr,
        photos: data.photos,
        images: data.images,
        edit_image: data.images ? data.url + data.images : '',
        keywords: data.keywords ? data.keywords.split(';') : [],
        from_time: data.from_time,
        to_time: data.to_time,
        from_time_cate: data.from_time_cate,
        to_time_cate: data.to_time_cate,
        latitude: data.latitude ? data.latitude : '',
        longitude: data.longitude ? data.longitude : '',
        other_rating: data.other_rating ? data.other_rating : 0,
        schoolType: data.sub_categories.split(','),
        min_age: data.min_age,
        has_trial: data.has_trial,
        has_scl: data.scl_id === 0 ? 2 : 1,
        scl_link: data.scl_id,
        edited: data.edited,
        edited_data: edited_data
      });
      this.Geocode_location(data.google_location);
    }
  }
  UNSAFE_componentWillMount() { }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  async Cat_type() {
    let response = await FetchCall.getSubCategory('2');
    console.log('categoryTypeList', response);
    if (response) {
      this.setState({ categoryTypeList: response.results });
    }
  }
  async getboe() {
    let response = await FetchCall.getSchoolListDatas('boe');
    console.log('boeList', response);
    if (response) {
      this.setState({ boeList: response.results });
    }
  }
  async getdocuments() {
    let response = await FetchCall.getSchoolListDatas('documents');
    console.log(response);
    if (response) {
      this.setState({ documnets_drop: response.results });
    }
  }
  async getpayment_type() {
    let response = await FetchCall.getSchoolListDatas('payment_type');
    console.log(response);
    if (response) {
      this.setState({ mopList: response.results });
    }
  }
  async getfacilities() {
    let response = await FetchCall.getSchoolListDatas('facilities');
    console.log(response);
    if (response) {
      this.setState({ facilitiesList: response.results });
    }
  }
  async gettiming() {
    let response = await FetchCall.getSchoolListDatas('timing');
    console.log(response);
    if (response) {
      this.setState({ timingList: response.results });
    }
  }
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
    this.clearValidationErr(propName);
    if (e.target.name === 'google_location')
      this.Geocode_location();
  };
  onSelect = (selectedList) => {
    let keywords = [];
    selectedList.forEach((item, i) => {
      keywords.push(item)
    });
    this.setState({
      keywords: keywords,
    });
  }
  onRemove = (selectedList, removedItem) => {
    let keywords = [];
    selectedList.forEach((item, i) => {
      keywords.push(item)
    });
    this.setState({
      keywords: keywords,
    });
  }
  getSclList = () => {
    sclList().then(res => {
      if (res.status === 1) {
        this.setState({
          sclList: res.list
        })
      }
    })
  }

  handleFile = (e) => {
    // this.Geocode_location();
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({ [propName]: files });
    const reader = new FileReader();
    let THIS = this;
    reader.addEventListener("load", function () {
      // convert image file to base64 string
      THIS.setState({
        tempBanner: reader.result
      });
    }, false);

    if (files) {
      reader.readAsDataURL(files);
    } else {
      THIS.setState({
        tempBanner: ''
      });
    }
  };

  handleFileMultiple = (e) => {
    this.setState({ [e.target.name]: e.target.files });
  };

  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);

    this.setState({ [propName]: value });

  };


  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    });
  }

  Geocode_location(location = '') {
    Geocode.fromAddress(location ? location : this.state.google_location).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        console.log(lat, lng);
        if (lat && lng)
          this.get_location(lat, lng);
      },
      error => {
        console.error(error);
      }
    );

  }


  get_location(lat, lng) {
    this.setState({
      latitude: lat,
      longitude: lng
    });
  }

  LocationDataList = async () => {
    try {
      const res = await getLocationList();
      if (res.status === 1) {
        console.log('location_list', res.results)

        this.setState({
          location_list: res.results,
          error: false
        });
      }

    } catch (error) {
      this.setState({ error: true });
    }
  };

  removeImage = e => {
    var delete_array = this.state.delete_array;
    delete_array.push(e)
    const updated = this.state.attachment_file.filter(item => item.name !== e)
    this.setState({
      attachment_file: updated,
      delete_array: delete_array,
    })
  }
  remove_img() {
    jQuery('#edit_image').remove();
  }
  loadFile(e) {
    var files = e.target.files
    this.setState({ attachment_file_length: files.length })
    if (files.length > 0) {
      jQuery('.upload-space').addClass('hide')
      jQuery('.upload-thumb').removeClass('hide')
      var fileArra = this.state.attachment_file

      //console.log('fileArra',fileArra)
      //var fileThumbArra = this.state.imgThumb;
      for (var i = 0; i < files.length; i++) {
        fileArra.push(e.target.files[i])
        this.setState({
          selectedFile: URL.createObjectURL(e.target.files[i]),
          attachment_file: fileArra
        })
      }
      this.clearValidationErr('attachment_file');
    }
  }
  handlePreview = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        preview: true
      })
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  render() {
    const { edited_data, edited } = this.state;
    this.validator.purgeFields();

        return (  
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Pre-Schools Info Management</h4>
                                   
                   <div className="row">

                <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                  <div className="">
                      <div id="company-info" className="tab-pane active">
                      <form
                        method="post"
                        onSubmit={this.handlePreview}
                        autoComplete="off"
                        className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no"
                      >
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.registration_no !== this.state.registration_no) && 'edited-field'}>
                                Registration No {this.state.user_type === 1 && <span className="astrick">*</span>}
                              </label>
                              <input

                                type="text"
                                className="form-control"
                                name="registration_no"
                                value={this.state.registration_no}
                                onChange={this.handleChange}
                              />
                              {
                                this.state.user_type == 1 &&
                                (
                                  this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
                                )
                              }

                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.owner_name !== this.state.ownerName) && 'edited-field'}>
                                Owner Name {this.state.user_type === 1 && <span className="astrick">*</span>}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="ownerName"
                                value={this.state.ownerName}
                                onChange={this.handleChange}
                              />
                              {
                                this.state.user_type === 1 &&
                                (
                                  this.validator.message('Owner Name', this.state.ownerName, 'required', { className: 'text-danger' })
                                )
                              }
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.organisation_name !== this.state.schoolName) && 'edited-field'}>
                                Organization Name <span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                name="schoolName"
                                value={this.state.schoolName}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {
                                this.state.user_type === 1 &&
                                (
                                  this.validator.message('Organization Name', this.state.schoolName, 'required', { className: 'text-danger' })
                                )
                              }
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.sub_categories !== this.state.schoolType) && 'edited-field'}>
                                Organization type<span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  className="form-control selectpicker"
                                  onChange={this.handleSelect}
                                  name="schoolType"
                                  value={this.state.schoolType}
                                >
                                  {this.state.categoryTypeList.length > 0 &&
                                    this.state.categoryTypeList.map((item, i) => {
                                      return (
                                        <option value={item.category_id} >
                                          {item.category_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Organization type', this.state.schoolType, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">
                                Address Information
                              </span>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.email_id !== this.state.email_id) && 'edited-field'}>
                                Email Id<span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                name="email_id"
                                value={this.state.email_id}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.phone_number !== this.state.phone_number) && 'edited-field'}>
                                Phone Number<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="phone_number"
                                value={this.state.phone_number}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Phone Number', this.state.phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })} */}
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.state !== this.state.state) && 'edited-field'}>
                                State<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="state"
                                value={this.state.state}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.location !== this.state.location) && 'edited-field'}>
                                Location<span className="astrick">*</span>
                              </label>
                              <select
                                name="location"
                                id="location"
                                onChange={this.handleSelect}
                                value={this.state.location}
                                className="form-control selectpicker"
                              >
                                {this.state.location_list.length > 0 &&
                                  this.state.location_list.map((item, i) => {
                                    return (
                                      <option value={item.location} >
                                        {item.location}
                                      </option>
                                    )
                                  })}
                              </select>
                              {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.pincode !== this.state.pincode) && 'edited-field'}>
                                Pincode<span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                name="pincode"
                                value={this.state.pincode}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.address !== this.state.address) && 'edited-field'}>
                                Address<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="address"
                                value={this.state.address}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                            </div>
                            {/* <div className="form-group col-md-4">
                              <label>
                                Country<span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="country"
                                value={this.state.country}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Country', this.state.country, 'required', { className: 'text-danger' })}
                            </div> */}

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.google_location !== this.state.google_location) && 'edited-field'}>
                                Google Location Address
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="google_location"
                                value={this.state.google_location}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Google Location Address', this.state.google_location, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.latitude !== this.state.latitude) && 'edited-field'}>
                                Latitude
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="latitude"
                                value={this.state.latitude}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.longitude !== this.state.longitude) && 'edited-field'}>
                                Longitude
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="longitude"
                                value={this.state.longitude}
                                onChange={this.handleChange}

                                className="form-control"
                              />
                              {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.about !== this.state.about_school) && 'edited-field'}>
                                About the School
                                <span className="astrick">*</span>
                              </label>
                              <textarea
                                type="text"
                                name="about_school"
                                value={this.state.about_school}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {/* {this.validator.message('About the School', this.state.about_school, 'required', { className: 'text-danger' })} */}
                              {this.validator.message('About the School', this.state.about_school, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.other_rating !== this.state.other_rating) && 'edited-field'}>
                                Google Rating
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                step='0.01'
                                name="other_rating"
                                value={this.state.other_rating}
                                onChange={this.handleChange}
                                max='5'
                                className="form-control"
                              />
                              {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Key Information</span>
                            </div>


                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.amenities !== this.state.facilities) && 'edited-field'}>Facilities<span className="astrick">*</span></label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  name="facilities"
                                  id="facilities"
                                  value={this.state.facilities}
                                  className="form-control selectpicker"
                                  onChange={this.handleSelect}
                                // data-live-search="true"

                                >
                                  {this.state.facilitiesList.length > 0 &&
                                    this.state.facilitiesList.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.facility}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Facilities', this.state.facilities, 'required', { className: 'text-danger' })}
                              </div>
                            </div>

                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited && ((edited_data.from_time !== this.state.from_time) || edited_data.from_time_cate !== this.state.from_time_cate)
                                    && 'edited-field'}>From Timing</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.from_time}
                                    name="from_time"
                                    title='Select Time'
                                  >
                                    {this.state.timingList.length > 0 &&
                                      this.state.timingList.map((item, i) => {
                                        return (
                                          <option value={item.id} >
                                            {item.timing}
                                          </option>
                                        )
                                      })}
                                  </select>

                                </div>
                              </div>

                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.from_time_cate}
                                    name="from_time_cate"
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                              {this.validator.message('From Timing', this.state.from_time, 'required', { className: 'text-danger' })}
                            </div>




                            <div className="form-group col-md-4 input-group-cus">
                              <div>
                                <label
                                  className={edited && ((edited_data.to_time !== this.state.to_time) || edited_data.to_time_cate !== this.state.to_time_cate)
                                    && 'edited-field'}>To Timing</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.to_time}
                                    name="to_time"
                                    title='Select Time'
                                  >
                                    {this.state.timingList.length > 0 &&
                                      this.state.timingList.map((item, i) => {
                                        return (
                                          <option value={item.id} >
                                            {item.timing}
                                          </option>
                                        )
                                      })}
                                  </select>

                                </div>
                              </div>

                              <div>
                                <label>&nbsp;</label>
                                <div className="custom-select-drop dropdown">
                                  <select
                                    className="form-control selectpicker"
                                    onChange={this.handleSelect}
                                    value={this.state.to_time_cate}
                                    name="to_time_cate"
                                  >
                                    <option value="AM">AM</option>
                                    <option value="PM">PM</option>
                                  </select>
                                </div>
                              </div>
                              {this.validator.message('To Timing', this.state.to_time, 'required', { className: 'text-danger' })}
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.number_of_teachers !== this.state.number_of_teachers) && 'edited-field'}>
                                Number of Teachers
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="number_of_teachers"
                                value={this.state.number_of_teachers}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Number of Teachers', this.state.number_of_teachers, 'required', { className: 'text-danger' })}
                            </div>

                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.est_year !== this.state.establishment_Year) && 'edited-field'}>
                                Establishment Year
                                <span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                name="establishment_Year"
                                value={this.state.establishment_Year}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Establishment Year', this.state.establishment_Year, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Establishment Year', this.state.establishment_Year, 'required|numeric|min:4|max:4', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.min_age !== this.state.min_age) && 'edited-field'}>
                                Min Age of Admission</label>
                              <input

                                type="text"
                                name="min_age"
                                 
                                value={this.state.min_age}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Min Age of Admission', this.state.min_age, 'required', { className: 'text-danger' })}
                            </div>
                            <div class="form-group col-md-4">
                              <label
                                className={edited && (edited_data.has_trial !== this.state.has_trial) && 'edited-field'}>
                                Is Trial Class Available?<span class="astrick">*</span></label>
                              <select
                                className='form-control selectpicker'
                                name='has_trial'
                                value={this.state.has_trial}
                                title='Select'
                                onChange={this.handleSelect}>
                                <option value='1'>Yes</option>
                                <option value='2'>No</option>
                              </select>
                              {this.validator.message('Trial Class', this.state.has_trial, 'required', { className: 'text-danger error-msg' })}

                            </div>
                            <div class="form-group col-md-4">
                              <label
                                className={edited && (edited_data.has_scl !== this.state.has_scl) && 'edited-field'}>
                                Is Pre School has School<span class="astrick">*</span></label>
                              <select
                                className='form-control selectpicker'
                                name='has_scl'
                                value={this.state.has_scl}
                                title='Select'
                                onChange={this.handleSelect}>
                                <option value='1'>Yes</option>
                                <option value='2'>No</option>
                              </select>
                              {this.validator.message('School', this.state.has_scl, 'required', { className: 'text-danger error-msg' })}

                            </div>
                            {(this.state.has_scl === 1 && (
                              <div class="form-group col-md-4">
                                <label
                                  className={edited && (edited_data.scl_id !== this.state.scl_link) && 'edited-field'}>
                                  Select School<span class="astrick">*</span></label>
                                <select
                                  className='form-control selectpicker'
                                  name='scl_link'
                                  value={this.state.scl_link}
                                  title='Select' data-live-search='true'
                                  onChange={this.handleSelect}>
                                  {this.state.sclList.map((item, i) => {
                                    return (
                                      <option value={item.id}>{item.name}</option>
                                    )
                                  })}
                                </select>
                                {this.validator.message('School', this.state.scl_link, 'required', { className: 'text-danger error-msg' })}

                              </div>
                            ))}
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.website !== this.state.website) && 'edited-field'}>
                                Website<span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                name="website"
                                value={this.state.website}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Website', this.state.website, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Website', this.state.website, 'required|checkUrl', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.keywords !== this.state.keywords) && 'edited-field'}>
                                Keywords</label>

                              <Multiselect
                                isObject={false}
                                options={this.state.keywordsArr} // Options to display in the dropdown
                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                onSelect={this.onSelect} // Function will trigger on select event
                                onRemove={this.onRemove} // Function will trigger on remove event
                              />
                              {/* <textarea
                                name="keywords"
                                value={this.state.keywords}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="ex: school,category names,location name,etc"
                              ></textarea> */}
                              {/* {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })} */}
                            </div>

                          </div>
                        </div>

                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">
                                Admission Details
                              </span>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.admission_link !== this.state.admission_link) && 'edited-field'}>
                                Admission Link <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="admission_link"
                                value={this.state.admission_link}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Admission Link', this.state.admission_link, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Admission Link', this.state.admission_link, 'required|url', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.processing_fee !== this.state.processing_fee) && 'edited-field'}>
                                Application Fees <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="processing_fee"
                                value={this.state.processing_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Application Fees', this.state.processing_fee, '', { className: 'text-danger' })}
                              {/* {this.validator.message('Application Fees', this.state.processing_fee, 'required|numeric', { className: 'text-danger' })} */}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.required_document !== this.state.required_document) && 'edited-field'}>
                                Documents </label>
                              <div className="custom-select-drop dropdown">
                                <select
                                  multiple
                                  name="required_document"
                                  onChange={this.handleSelect}
                                  value={this.state.required_document}
                                  className="form-control selectpicker"
                                >
                                  {this.state.documnets_drop.length > 0 &&
                                    this.state.documnets_drop.map((item, i) => {
                                      return (
                                        <option value={item.id} >
                                          {item.document_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                <br />
                                {this.validator.message('Documents', this.state.required_document, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.admission_process !== this.state.admission_process) && 'edited-field'}>
                                Admission Process</label>
                              <textarea
                                name="admission_process"
                                value={this.state.admission_process}
                                onChange={this.handleChange}
                                className="form-control"
                              ></textarea>
                              {this.validator.message('Admission Process', this.state.admission_process, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.avg_fee !== this.state.avg_anual_fee) && 'edited-field'}>
                                Indicative Annual Fee(INR)
                                <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="avg_anual_fee"
                                value={this.state.avg_anual_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Indicative Annual Fee', this.state.avg_anual_fee, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.other_fee !== this.state.other_fee) && 'edited-field'}>
                                Other Fees <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="other_fee"
                                value={this.state.other_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Other Fees', this.state.other_fee, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.admit_fee !== this.state.addmission_fee) && 'edited-field'}>
                                Admission Fees <span className="astrick">*</span>
                              </label>
                              <input
                                type="text"
                                name="addmission_fee"
                                value={this.state.addmission_fee}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })}
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.is_refund !== this.state.isrefund) && 'edited-field'}>
                                Is Refundable (Admission Fees)
                                <span className="astrick">*</span>
                              </label>
                              <br />
                              <input
                                type="radio"
                                name="isrefund"
                                value="1"
                                checked={this.state.isrefund === 1}
                                onChange={this.handleChange}
                              />
                              Yes&nbsp;&nbsp;
                              <input
                                type="radio"
                                value="2"
                                name="isrefund"
                                checked={this.state.isrefund === 2}
                                onChange={this.handleChange}
                              />
                              No
                              {this.validator.message('Is Refundable', this.state.isrefund, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <span className="form-legend">Images</span>
                            </div>
                            <div className="form-group col-md-4">
                              <label
                                className={edited && (edited_data.images !== this.state.images) && 'edited-field'}>
                                Banner Image <span className="astrick">*</span>
                              </label>
                              <input
                                type="file"
                                name="images"
                                onChange={this.handleFile}
                                className="form-control"
                              />
                              {this.validator.message('Banner Image', this.state.images, '', { className: 'text-danger error-msg' })}
                              {/* {this.validator.message('Banner Image', this.state.images, 'checkExist', { className: 'text-danger error-msg' })} */}
                            </div>
                            {(this.state.edit_image !== '' || this.state.tempBanner !== '') &&
                              (
                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                  <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Img" class="img-thumbnail" />

                                </div>
                              )
                            }

                            <div class="col-md-12 float-left mt-4 p-0">
                              <label
                                className={edited && (edited_data.photos !== this.state.photos) && 'edited-field'}>
                                Gallery Images <span className="astrick">*</span>
                              </label>
                            </div>

                            <div class="col-md-12 float-left mt-4 p-0">

                              <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                <div className='upload-wizard'>
                                  <div className='upload-thumb'>
                                    <ul className='list-inline'>
                                      {this.state.attachment_file.map((file_data, index) => {

                                        var file_url;
                                        if (file_data.name) {
                                          let url = file_data.image_thumb ? file_data.image_thumb : '';
                                          if (url !== '') {
                                            file_url = file_data.image_thumb;
                                          } else {
                                            file_url = URL.createObjectURL(file_data);
                                          }

                                          // var file_url = URL.createObjectURL(file_data)
                                          // var file_name = file_data.name
                                          if (file_data.type === 'application/pdf') {
                                            return (
                                              <li className='previewImg'>
                                                <div className='thumb-img'>
                                                  <img
                                                    src={file_url}
                                                    alt='preview'
                                                    title={file_data.name}
                                                  />
                                                </div>
                                                {/* <span className='file-name'>{file_name}</span> */}
                                                <a href='javascript:;' className='del-btn' onClick={() => {
                                                  this.removeImage(file_data.name)
                                                }}>
                                                  <img
                                                    src={'../../../assets/images/close-icon-white.svg'}
                                                    alt='delete'
                                                  />
                                                </a>
                                              </li>
                                            )
                                          } else {
                                            return (
                                              <li className='previewImg'>
                                                <div className='thumb-img'>
                                                  <img
                                                    src={file_url}
                                                    alt='preview'
                                                    title={file_data.name}
                                                  />
                                                </div>
                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                <a
                                                  href='javascript:;'
                                                  className='del-btn'
                                                  onClick={() => {
                                                    this.removeImage(file_data.name)
                                                  }}
                                                >
                                                  <img
                                                    src={'../../../assets/images/close-icon-white.svg'}
                                                    alt='delete'
                                                  />
                                                </a>
                                              </li>
                                            )
                                          }
                                        }
                                        return;
                                      })}
                                      <li className='addMore'>
                                        <input
                                          type='file'
                                          name='imgInp[]'
                                          id='imgInp2'
                                          className='add_img'
                                          multiple
                                          onChange={this.loadFile.bind(this)}
                                          accept="image/x-png,image/gif,image/jpeg"
                                        />
                                        <a href='javascript:;' className='add-more'>
                                          <div>
                                            <img src={'../../../assets/images/upload-icon.svg'} alt='icon' />
                                            Add more
                                          </div>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>

                                </div>

                              </div>
                              {this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })}
                              {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}
                            </div>

                          </div>
                        </div>
                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-primary btn-sm">Preview</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>  


                </div>
              </div>
            </div>

             {this.preview()}

            </AdminLayout>
               
      </React.Fragment >
    );
  }
  
preview = () => {
    let from_time = this.state.timingList.map((item) => {
      if (item.id === this.state.from_time) return item.timing
      return;
    })
    from_time = from_time.filter(n => n).toString();
    let to_time = this.state.timingList.map((item) => {
      if (item.id === this.state.to_time) return item.timing
      return;
    })
    to_time = to_time.filter(n => n).toString();
    return (
      <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
        <ModalBody className=''>
          <Row>
            <Col md='12'>
              <img src='/assets/images/user-header.png' className='preview-header' alt="preview header"/>
            </Col>
          </Row>
          <Row className='pv-banner'>
            <Col className='pv-banner-bg' md='12'>
              <div className='title-section'>
                <p className="banner-title">{this.state.schoolName}</p>
                <p className="banner-address">{this.state.address}</p>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>About the School</h4>
                <p className="">{this.state.about_school}</p>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Key Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Establishment Year</b></div>
                    <div className='key-po'>
                      <p>{this.state.establishment_Year}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Number of Teachers</b></div>
                    <div className='key-po'>
                      <p>{this.state.number_of_teachers}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Timing</b></div>
                    <div className='key-po'>
                      <p>
                        {from_time === 'NA' || to_time === 'NA' ? 'NA' :
                          `${from_time} ${this.state.from_time_cate} - ${to_time} ${this.state.to_time_cate}`}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Is Refundable (Admission Fees)</b></div>
                    <div className='key-po'>
                      <p>
                        {this.state.isrefund === 1 ? 'Yes' : 'No'}
                      </p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Min Age of Admission</b></div>
                    <div className='key-po'>
                      <p>{this.state.min_age}</p>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='type-n7ngd'><b>Is Trial class Available</b></div>
                    <div className='key-po'>
                      <p>
                        {this.state.has_trial === 0 ? 'NA' :
                          (this.state.has_scholarship === 1 ? 'Yes' : 'No')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Amenities</h4>
                <div className='row'>
                  {this.state.facilities.map((item) => {
                    let fac_data = this.state.facilitiesList.filter((data) => data.id === item);
                    if (fac_data.length > 0) {
                      return (
                        <div className='col-md-4'>
                          <div className=''>
                            {fac_data[0].facility}
                          </div>
                        </div>
                      )
                    }
                    return;
                  })}

                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Gallery</h4>
                <div className='row'>
                  {this.state.attachment_file.map((item) => {
                    console.log('********', item);
                    if (item.image_thumb) {
                      return (
                        <div className='col-md-4'>
                          <img src={item.image_thumb} className='preview-image' alt="preview"/>
                        </div>
                      )
                    } else if (item.name) {
                      let file_url = URL.createObjectURL(item);
                      return (
                        <div className='col-md-4'>
                          <img src={file_url} className='preview-image' alt="preview"/>
                        </div>
                      )
                    }
                    return;
                  })}
                  {this.state.attachment_file.length === 0 && (
                    <div className='col-md-4'>No Gallery Images Found</div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Fees Structure</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    Indicative Annual Fee : {this.state.avg_anual_fee > 0 ? this.state.avg_anual_fee : 'NA'}
                  </div>
                  <div className='col-md-4'>
                    Recurring Fees : {this.state.addmission_fee > 0 ? this.state.addmission_fee : 'NA'}
                  </div>
                  <div className='col-md-4'>
                    Other Fees : {this.state.other_fee > 0 ? this.state.other_fee : 'NA'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Admission Details</h4>
                <div className='row'>
                  <div className='col-md-6'>
                    Admission Link : {this.state.admission_link ?
                      (<a href={this.state.admission_link}>Link</a>) : 'NA'}
                  </div>
                  <div className='col-md-6'>
                    Admission Process : {this.state.admission_process}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Required Documents</h4>
                <div className='row'>
                  {this.state.required_document.map((item) => {
                    let redoc_data = this.state.documnets_drop.filter((data) => data.id === item);
                    if (redoc_data.length > 0) {
                      return (
                        <div className='col-md-4'>
                          <div className=''>
                            {redoc_data[0].document_name}
                          </div>
                        </div>
                      )
                    }
                    return;
                  })}

                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <div className='title-section'>
                <h4>Contact Information</h4>
                <div className='row'>
                  <div className='col-md-4'>
                    Email Id : {this.state.email_id}
                  </div>
                  <div className='col-md-4'>
                    Contact : {this.state.phone_number}
                  </div>
                  <div className='col-md-4'>
                    Website : {this.state.website}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className='pv-section'>
            <Col className='' md='12'>
              <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                {this.state.edited && this.state.role === 1 ? 'Approve' : 'Submit'}
              </button>
              {this.state.edited && this.state.role === 1 && (
                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                  onClick={this.handleReject}>
                  Reject
                </button>
              )}
              <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                onClick={() => { this.setState({ preview: false }) }}>Close</button>
            </Col>
          </Row>
        </ModalBody>
      </Modal >
    )
  }
  handleReject = (e) => {
    e.preventDefault();
    let req = JSON.stringify({
      id: this.state.getId
    })
    let toastr = '';
    presclReject(req).then((res => {
      if (res.status === 1) {
        toastr = window.toastr.success;
        toastr('success', {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right"
        });
        window.location.href = document.referrer;
      }
    }))
  }
  handleSubmit = (e) => {
    e.preventDefault();
    console.log('**', this.validator.getErrorMessages())
    if (this.validator.allValid()) {


      let insData = {
        getid: this.state.getId ? this.state.getId : '',
        login_id: this.state.login_id,
        registration_no: this.state.registration_no,
        owner_name: this.state.ownerName,
        organisation_name: this.state.schoolName,
        sub_categories: this.state.schoolType,
        email_id: this.state.email_id,
        phone_number: this.state.phone_number,
        // fax_number: this.state.fax_number,
        state: this.state.state,
        website: this.state.website,
        location: this.state.location,
        address: this.state.address,
        country: this.state.country,
        pincode: this.state.pincode,
        about: this.state.about_school,
        google_location: this.state.google_location,
        number_of_teachers: this.state.number_of_teachers,
        edu_type: this.state.board_of_education,
        timing: this.state.opening_timimg,
        // paymnet: this.state.mode_of_payment,
        est_year: this.state.establishment_Year,
        amenities: this.state.facilities,
        avg_fee: this.state.avg_anual_fee,
        other_fee: this.state.other_fee,
        processing_fee: this.state.processing_fee,
        admission_process: this.state.admission_process,
        addmission_fee: this.state.addmission_fee,
        admission_link: this.state.admission_link,
        required_document: this.state.required_document,
        is_refund: this.state.isrefund,
        images: this.state.images,
        photos: this.state.attachment_file,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        from_time: this.state.from_time,
        to_time: this.state.to_time,
        delete_array: this.state.delete_array,
        from_time_cate: this.state.from_time_cate,
        to_time_cate: this.state.to_time_cate,
        keywords: this.state.keywords ? this.state.keywords.join(';') : '',
        other_rating: this.state.other_rating,
        min_age: this.state.min_age,
        has_trial: this.state.has_trial,
        scl_link: this.state.scl_link,
        role: this.state.role
      }


      // jQuery("#btnSubmit").attr('disabled', true);
      addPreschool(insData).then((res) => {
        if (res.status === 1) {
          alert("Success");
          window.location.href = document.referrer;
        } else {
          jQuery("#btnSubmit").attr('disabled', false);
          alert("Error in saving");
        }
      });

    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };




}

export default verticalPreSchoolEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalPreSchoolEdit.jsx